import React from "react";
import {Alert, Avatar, Button, Card, notification, Popconfirm, Space, Table, Tag, Typography, Modal, Checkbox, Input, InputNumber, Switch, Tooltip} from "antd";
import SummaryOrderView from "../dialogs/SummaryOrderView";
import AddInstructionsDialog from "../dialogs/AddInstructionsDialog";
import {getCategoryColor} from "./StacksTables";
import {UserDataDtoGenderEnum} from "acc-rest-client";
import {calculate_age} from "./LetterTables";
import {
    DownloadOutlined,
    DragOutlined,
    FileExcelOutlined,
    FilePdfOutlined,
    FileProtectOutlined,
    LeftCircleOutlined,
    SafetyCertificateOutlined, SafetyOutlined, FileWordOutlined, MailOutlined, PlusCircleOutlined, PrinterOutlined,
    SyncOutlined, WarningOutlined,
} from "@ant-design/icons";
import {useHistory, useParams} from "react-router-dom";
import {
    closeStack,
    deliverStack,
    extendStack,
    downloadAttachment,
    downloadStackAttachment,
    downloadMultipleLetters,
    getUserSettings,
    loadMyStacks,
    saveUserSettings,
    submitStack,
    submitReviewStack,
    updateStackSummaryOrder,
    addInstructions
} from "../../store/app/app.slice";
import {useDispatch} from "react-redux";
import {StackDto} from "ps-letter-mgmtrest-client";
import {
    getLanguagesLabel,
    getProcessedLetterStatusColor,
    getProcessedLetterStatusLabel,
    getTopicsLabel, letterLanguageFilterDropdown,
    letterStatusFilterDropdown,
    getCustomUnicodeFlagIcon
} from "../helper/labelHelper";
import moment from "moment/moment";
import gender_male2_icon from "../../assets/ps-images/gender_male2_icon.png";
import gender_female_icon from "../../assets/ps-images/gender_female_icon.png";
import gender_unknown_icon from "../../assets/ps-images/unknown-avatar.png";
import {ProcessedLetterDto} from "ps-letter-mgmtrest-client";
import {getAuthenticatedUser} from "../../utils/authHelper";
import {getSortedGroupedLetters} from "../../utils/stackSortingUtils";
import * as XLSX from 'xlsx';
import {useState, useEffect, useRef} from "react";
import {useSelector} from "react-redux";

const { Title } = Typography;
const { TextArea } = Input;

export default function StackDetailTable({ stack, letters, showNewStackRequestModal, inProcess, refreshStack}) {
    const history = useHistory();
    const dispatch = useDispatch();
    const params = useParams();
    const [isExportModalVisible, setIsExportModalVisible] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState({});
    const [isSummaryOrderModalVisible, setIsSummaryOrderModalVisible] = useState(false);
    const [userSettingsSummaryOrder, setUserSettingsSummaryOrder] = useState({});
    const [searchText, setSearchText] = useState("");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isGrouped, setIsGrouped] = useState(stack?.assignedStackType === "ANSWER"
        || stack?.assignedStackType === "REVIEW_ANSWER");
    const [isInstructionsModalVisible, setIsInstructionsModalVisible] = useState(false);
    const { summaries, isDeliverStackLoading } = useSelector((state) => state.app);
    const [isExtendModalVisible, setIsExtendModalVisible] = useState(false);
    const [extendAmount, setExtendAmount] = useState(10);
    
    // Load user settings summary order when component mounts and stack is SUMMARY type
    useEffect(() => {
        if (stack && stack.assignedStackType === "SUMMARY") {
            dispatch(getUserSettings({
                finalData: { settingName: "SUMMARY_ORDER" },
                callbackSuccess: (response) => {
                    if (response && response.settingData) {
                        setUserSettingsSummaryOrder(response.settingData);
                    }
                },
                callbackError: (error) => {
                    console.error("Error loading user settings:", error);
                }
            }));
        }
    }, [stack, dispatch]);
    
    const allColumns = {
        'ID': true,
        'Present to Huzoor': true,
        'Summary Title English': true,
        'Summary Title Urdu': true,
        'Summary Topics': true,
        'Summary Notes': true,
        'Answer Language': true,
        'Custom Answer': true,
        'Advice from Huzoor': true,
        'Internal Status': true,
        'Assigned To': true,
        'Attachment ID Letter': true,
        'Filtered At': true,
        'Filtered By': true,
        'Filtered By Name': true,
        'Attachment ID Summary': true,
        'Summary At': true,
        'Summary Title Original': true,
        'Summary By': true,
        'Summary By Name': true,
        'Answer At': true,
        'Answer Original': true,
        'Answer By': true,
        'Answer By Name': true,
        'Attachment ID Answer': true,
        'Created': true,
        'Created By': true,
        'Created By Name': true,
        'Modified': true,
        'Modified By': true,
        'Modified By Name': true,
        'Letter ID': true,
        'Letter Content': true,
        'Letter Category': true,
        'Letter Language': true,
        'Letter Created': true,
        'Letter Updated': true,
        'Letter Created By': true,
        'Letter Updated By': true,
        'Letter Version': true,
        'Sender ID': true,
        'Sender First Name': true,
        'Sender Last Name': true,
        'Sender Urdu Name': true,
        'Sender AIMS ID': true,
        'Sender Birthdate': true,
        'Sender Street Line 1': true,
        'Sender Street Line 2': true,
        'Sender ZIP Code': true,
        'Sender City': true,
        'Sender State': true,
        'Sender Country': true,
        'Sender Country Code': true,
        'Sender Country Flag': true,
        'Sender Jamaat': true,
        'Sender Gender': true,
        'Sender Contact Number': true,
        'Sender Approval Status': true,
        'Sender Email': true,
        'Sender Email Verified': true,
        'Sender Created Timestamp': true,
        'Review Status': true,
        'Delivery Method': true,
        'Reviewed At': true,
        'Reviewed By': true,
        'Reviewed By Name': true,
        'Attachment ID Answer PDF': true,
        'Attachment ID Answer PDF Original': true,
        'Modified Answer PDF Uploaded By': true,
        'Modified Answer PDF Uploaded At': true
    };

    const navigateToLetterView = (record) => {
        let processPathPrefix= "/process/"+params?.stackType;
        
        if(inProcess)
        {
            history.push(processPathPrefix+"/stacks/"+params?.stackId+"/"+record.id)
        }else{
            history.push("/stacks/"+params?.stackId+"/"+record.id)
        }
    }
    
    const navigateToStacksView = () => {
        let processPathPrefix= "/process/"+params?.stackType;

        if(inProcess)
        {
            dispatch(loadMyStacks({}));
            history.push(processPathPrefix+"/stacks")
        }else{
            history.push("/stacks")
        }
    }

    const areLetterProcessed = (status, percentage) => {
        // Check at least 50% of letters are filtered, ignoring forwarded letters
        const nonForwardedLetters = letters.filter(letter => letter.internalStatus !== 'LETTER_INTERNAL_FORWARDED');
        const filteredLettersLength = filteredLettersByStatusLength(status);
        return (filteredLettersLength / nonForwardedLetters.length) >= percentage;
    }

    const isReviewMode = stack?.assignedStackType === "REVIEW_ANSWER";

    /**
     * Whether the table draws summary header rows.
     *
     * Answer and review stacks both do: a reviewer checks the letters against
     * the same summaries, in the same groups, the answers were written
     * against. The condition used to be spelled out at seventeen separate
     * call sites, each naming the answer stack explicitly, which is how the
     * review stack quietly ended up without any grouping at all.
     */
    const groupsBySummary = isGrouped
        && (stack?.assignedStackType === "ANSWER" || stack?.assignedStackType === "REVIEW_ANSWER");

    const REVIEWED_STATUSES = ["ACCEPTED", "REPLACED", "SKIPPED"];

    const reviewableLetters = () =>
        letters.filter(l => l.internalStatus !== 'LETTER_INTERNAL_FORWARDED');

    const reviewedCount = () =>
        reviewableLetters().filter(l => REVIEWED_STATUSES.includes(l.reviewStatus)).length;

    const reviewableCount = () => reviewableLetters().length;

    /**
     * What still stands between this review stack and delivery.
     *
     * Mirrors submitStack's validation, so the button is disabled in exactly
     * the cases the server would refuse. The generic percentage gate is not
     * enough on its own: it counts letters at LETTER_ANSWER_REVIEWED, and
     * uploading a custom PDF sets that status without choosing a route — so a
     * stack of replaced letters looked ready, enabled the button, and was then
     * rejected (or worse, queued letters the poller could not deliver).
     */
    const deliveryBlockers = () => {
        const pending = reviewableLetters();
        return {
            unreviewed: pending.filter(l => l.reviewStatus !== "ACCEPTED" && l.reviewStatus !== "REPLACED").length,
            withoutMethod: pending.filter(l => !l.deliveryMethod).length,
            withoutPdf: pending.filter(l => !l.attachmentIdAnswerPdf).length,
        };
    };

    /** The blockers as a sentence, or null when delivery can start. */
    const deliveryBlockedReason = () => {
        const blockers = deliveryBlockers();
        const reasons = [];
        if (blockers.unreviewed > 0) {
            reasons.push(blockers.unreviewed + " letter(s) not reviewed yet");
        }
        if (blockers.withoutMethod > 0) {
            reasons.push(blockers.withoutMethod + " without a delivery method");
        }
        if (blockers.withoutPdf > 0) {
            reasons.push(blockers.withoutPdf + " without an answer PDF");
        }
        return reasons.length > 0 ? "Cannot start the delivery yet: " + reasons.join(", ") + "." : null;
    };

    const allLettersReviewed = () => {
        const total = reviewableCount();
        return total > 0 && reviewedCount() === total;
    };

       const DELIVERY_POLL_INTERVAL_MS = 5000;

    const deliveryProgress = () => {
        const countByStatus = (...statuses) => letters.filter(l => statuses.includes(l.internalStatus)).length;
        const pending = countByStatus("LETTER_ANSWER_READY_FOR_DELIVERY");
        const failed = countByStatus("LETTER_ANSWER_DELIVERY_FAILED");
        const delivered = countByStatus("LETTER_ANSWER_DELIVERED");
        const downloaded = countByStatus("LETTER_ANSWER_DOWNLOADED");
        const emailed = delivered + downloaded;
        const posted = countByStatus("LETTER_ANSWER_PRINTED");
        const total = pending + failed + emailed + posted;
        return { pending, failed, delivered, downloaded, emailed, posted, total, done: total - pending };
    };

    const showDeliveryProgress = isReviewMode
        && ["DELIVERED", "SUBMITTED", "CLOSED"].includes(stack?.status)
        && deliveryProgress().total > 0;

    const isDeliveryInProgress = showDeliveryProgress && deliveryProgress().pending > 0;

    const refreshStackRef = useRef(refreshStack);
    useEffect(() => {
        refreshStackRef.current = refreshStack;
    });

    useEffect(() => {
        if (!isDeliveryInProgress) {
            return undefined;
        }
        const timer = setInterval(() => {
            if (typeof refreshStackRef.current === 'function') {
                refreshStackRef.current();
            }
        }, DELIVERY_POLL_INTERVAL_MS);
        return () => clearInterval(timer);
    }, [isDeliveryInProgress]);

    const filteredLettersByStatusLength = (status) => {
        return filterLettersByStatus(status).length;
    }
    
    const filterLettersByStatus = (status) => {
        return letters.filter(letter => letter.internalStatus === status);
    }


    // Filter letters based on search text
    const filterData = (data) => {
        if (!searchText) return data;
        return data?.filter(item => {
            const searchableFields = [
                item.originalLetter?.id,
                item.originalLetter?.letterId,
                item.originalLetter?.sender?.firstName,
                item.originalLetter?.sender?.lastName,
                item.originalLetter?.sender?.email,
                item.originalLetter?.sender?.country?.defaultLabel,
                item.originalLetter?.sender?.jamaat,
                item.originalLetter?.category,
                item.originalLetter?.language,
                item.originalLetter?.content,
                item.internalStatus,
                item.assignedTo,
                item.summary?.titleEnglish,
                item.summary?.titleUrdu,
                item.answerLanguage,
                item.customAnswer
            ];
            return searchableFields.some(field => 
                field?.toString().toLowerCase().includes(searchText.toLowerCase())
            );
        });
    };

    const filteredLetters = filterData(letters);

    // Get sorted and grouped data using utility function
    const getGroupedData = () => {
        return getSortedGroupedLetters(stack, filteredLetters, isGrouped, stack.assignedStackType);
    };

    // Number the letter rows in display order. On an answer or review stack
    // that is also the order the answers Word file is generated in; on a
    // summary stack it is nothing but a serial for the list on screen, so the
    // reader can refer to a row by its number.
    let rowNumber = 0;
    const groupedData = getGroupedData().map(record =>
        record.isSummaryRow ? record : {...record, rowNumber: ++rowNumber}
    );

    const showRowNumbers = stack.assignedStackType === "ANSWER"
        || stack.assignedStackType === "REVIEW_ANSWER"
        || stack.assignedStackType === "SUMMARY";
    const columnsLettersStart = [
        ...(showRowNumbers ? [{
            title: "Nr.",
            dataIndex: "rowNumber",
            key: "rowNumber",
            width: 60,
            onCell: (record) => {
                if (groupsBySummary && record.isSummaryRow) {
                    return {
                        rowSpan: 1,
                        colSpan: 0 // Hide this column for summary rows
                    };
                }
                return {};
            }
        }] : []),
        {
            title: "Name",
            dataIndex: "originalLetter",
            className: "summary-row",
            sorter: (a, b) => {
                const aFirstName = a.originalLetter?.sender?.firstName || "";
                const bFirstName = b.originalLetter?.sender?.firstName || "";
                return aFirstName.localeCompare(bFirstName);
            },
            render: (letter, record) => {
                // Handle summary rows
                if (record.isSummaryRow) {
                    return (
                        <div className="arabic-font summary-row" style={{ 
                            fontWeight: 'bold', 
                            color: '#333',
                            backgroundColor: '#ffffff',
                            borderRadius: '12px',
                            border: '1px solid #e8e8e8',
                            fontSize: '24px',
                            textAlign: 'center',
                            width: '100%',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
                            borderTop: '1px solid #f0f0f0',
                            borderLeft: '1px solid #f0f0f0',
                            borderRight: '1px solid #d9d9d9',
                            borderBottom: '1px solid #d9d9d9'
                        }}>
                            <div className="summary-name" style={{ fontSize: '28px', fontWeight: 'bold', color: '#262626' }}>{record.summaryData?.titleUrdu}</div>
                            <div className="summary-count" style={{ 
                                fontSize: '20px', 
                                color: '#8c8c8c',
                                fontWeight: 'bold'
                            }}>
                                {record.summaryCount} letter(s)
                            </div>
                        </div>
                    );
                }
                
                // Handle letter rows
                if (letter && letter.sender) {
                    return (
                        <a onClick={() => navigateToLetterView(record)}>
                            <Avatar.Group>
                                <div style={{marginRight: "3px"}}>
                                    <Avatar
                                        src={letter.sender?.gender ? letter.sender.gender === UserDataDtoGenderEnum.Male ? gender_male2_icon : letter.sender.gender === UserDataDtoGenderEnum.Female ? gender_female_icon : gender_unknown_icon : gender_unknown_icon}
                                        shape="square" size="large">{letter.sender?.gender || ""}</Avatar>
                                </div>
                                <div className="avatar-info">
                                    <Title
                                        level={5}>{
                                        (letter.sender?.firstName || "") + " " +
                                        (letter.sender?.lastName || "") +
                                        " (" +
                                        (letter.sender?.birthdate ? calculate_age(letter.sender.birthdate) : "0")
                                        + ")"}
                                    </Title>
                                    <p>{letter.sender?.email || ""}</p>
                                </div>
                            </Avatar.Group>
                        </a>
                    );
                }
                return "N/A";
            },
            onCell: (record) => {
                if (groupsBySummary) {
                    return {
                        rowSpan: record.nameRowSpan || 1,
                        colSpan: record.isSummaryRow ? columnsLetters.length : 1
                    };
                }
                return {};
            }
        },
        {
            title: "Jamā'at, Country",
            dataIndex: ["originalLetter", "sender"],
            key: "country",
            sorter: (a, b) => {
                const aCountry = a.originalLetter?.sender?.country?.defaultLabel || "";
                const bCountry = b.originalLetter?.sender?.country?.defaultLabel || "";
                return aCountry.localeCompare(bCountry);
            },
            render: (sender, record) => {
                // Handle letter rows only (summary rows are hidden)
                if (sender) {
                    const letterContent = record.originalLetter?.content || "";
                    const isUrduStack = stack.assignedLanguages && 
                        stack.assignedLanguages.length > 0 && 
                        stack.assignedLanguages[0].toLowerCase().includes('urdu');
                    
                    return (
                        <Tooltip 
                            title={
                                <div style={{ 
                                    backgroundColor: '#f0f0f0',
                                    padding: '8px',
                                    borderRadius: '4px',
                                    border: '1px solid #d9d9d9',
                                    color: '#000',
                                    wordWrap: 'break-word'
                                }}
                                    className={isUrduStack ? "arabic-font arabic-font-edit" : ""}
                                >
                                    {letterContent}
                                </div>
                            } 
                            placement="top"
                            overlayStyle={{ 
                                backgroundColor: '#f0f0f0',
                                color: '#000',
                                maxWidth: '800px',
                                width: '800px'
                            }}
                        >
                            <span>
                                {sender?.jamaat ? sender.jamaat : ""}<br />
                                {sender?.country ? sender.country.defaultLabel : ""}&nbsp;
                                {getCustomUnicodeFlagIcon(sender?.country?.values?.flag)}
                            </span>
                        </Tooltip>
                    );
                }
                return "N/A";
            },
            onCell: (record) => {
                if (groupsBySummary && record.isSummaryRow) {
                    return {
                        rowSpan: 1,
                        colSpan: 0 // Hide this column for summary rows
                    };
                }
                return {};
            }
        },
        // {
        //     title: "Country",
        //     dataIndex: ["originalLetter", "sender", "country"],
        //     key: "country",
        //     sorter: (a, b) => a.originalLetter.sender.country.defaultLabel.localeCompare(b.originalLetter.sender.country.defaultLabel),
        //     render: (country) => (<span>{getCustomUnicodeFlagIcon(country?.values?.flag)} {country ? country.defaultLabel : ""} </span>),
        // },
        // {
        //     title: "Jamaat",
        // dataIndex: ["originalLetter", "sender", "jamaat"],
        // sorter: (a, b) => a.originalLetter.sender.jamaat.localeCompare(b.originalLetter.sender.jamaat),
        //     key: "jamaat",
        // },
        // {
        //     title: "Topic",
        //     dataIndex: ["originalLetter", "category"],
        //     key: "category",
        // sorter: (a, b) => a.originalLetter.category.localeCompare(b.originalLetter.category),
        //     render: (category) => (
        //         <Button type="text" style={{color: getCategoryColor(category),borderColor:getCategoryColor(category) ,borderStyle: 'solid'}}>
        //             {getTopicsLabel(category)}
        //         </Button>
        //     ),
        // },
        // {
        //     title: "Age",
        //     dataIndex: ["originalLetter", "sender","birthdate" ],
        // sorter: (a, b) => a.originalLetter.sender.birthdate.localeCompare(b.originalLetter.sender.birthdate),
        //     render: (birthdate) => (calculate_age(birthdate)),
        // },

        // {
        //     title: "Content",
        //     dataIndex: ["originalLetter", "content"],
        //     key: "content",
        // sorter: (a, b) => a.originalLetter.content.localeCompare(b.originalLetter.content),
        //     render: (content) => (content.substring(0, 20) + " ...")
        // }
        ];

    switch (stack.assignedStackType) {
        case "FILTRATION":
            columnsLettersStart.push(
                {
                    title: "Huzoor",
                    dataIndex: ["presentToHudhur"],
                    key: "hudhur",
                    filters: [
                        {
                            text: 'Present to Huzoor',
                            value: true,
                        },
                        {
                            text: 'Summarize',
                            value: false,
                        },
                        {
                            text: 'Not defined',
                            value: null,
                        },
                    ],
                    onFilter: (value, record) => record.presentToHudhur === value,
                    sorter: (a, b) => a.presentToHudhur - b.presentToHudhur,
                    render: (presentToHudhur, record) => {
                        // Handle letter rows only (summary rows are hidden)
                        return (
                            <div style={{
                                backgroundColor: '#f0f0f0',
                                color: presentToHudhur ? 'green' : presentToHudhur === false ? 'red' : 'grey',
                                borderRadius: '30%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }}>
                                {presentToHudhur ? '✓' : presentToHudhur === false ? '❌' : ''}
                            </div>
                        );
                    },
                    onCell: (record) => {
                        if (groupsBySummary && record.isSummaryRow) {
                            return {
                                rowSpan: 1,
                                colSpan: 0 // Hide this column for summary rows
                            };
                        }
                        return {};
                    }
                })
            break;
            case "SUMMARY":
                columnsLettersStart.push(
                    {
                        title: "Summarized",
                        dataIndex: [],
                        key: "summarized",
                        sorter: (a, b) => a.internalStatus - b.internalStatus,
                        render: (record) => {
                            // Handle letter rows only (summary rows are hidden)
                            return (
                                <div style={{
                                    backgroundColor: '#f0f0f0',
                                    color: (record.summary !== null ) ? 'green' : 'grey',
                                    borderRadius: '30%',
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    {record.summary !== null ? '✓' : ''}
                                </div>
                            );
                        },
                        onCell: (record) => {
                            if (groupsBySummary && record.isSummaryRow) {
                                return {
                                    rowSpan: 1,
                                    colSpan: 0 // Hide this column for summary rows
                                };
                            }
                            return {};
                        }
                    });
                break
            case "ANSWER":
                columnsLettersStart.push(
                    {
                        title: "Answered",
                        dataIndex: [],
                        key: "answered",
                        sorter: (a, b) => a.internalStatus - b.internalStatus,
                        render: (record) => {
                            // Handle letter rows only (summary rows are hidden)
                            return (
                                <div style={{
                                    backgroundColor: '#f0f0f0',
                                    color: (record.answer !== null || record.customAnswer !== null) ? 'green' : 'grey',
                                    borderRadius: '30%',
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                    fontWeight: 'bold'
                                }}>
                                    {(record.answer !== null || record.customAnswer !== null) ? '✓' : ''}
                                </div>
                            );
                        },
                        onCell: (record) => {
                            if (groupsBySummary && record.isSummaryRow) {
                                return {
                                    rowSpan: 1,
                                    colSpan: 0 // Hide this column for summary rows
                                };
                            }
                            return {};
                        }
                    },
                    {
                        title: "Summary Notes",
                        dataIndex: ["summaryNotes"],
                        key: "summaryNotes",
                        render: (summaryNotes, record) => {
                            // Handle letter rows only (summary rows are hidden)
                            if (summaryNotes && summaryNotes.trim()) {
                                return (
                                    <Tooltip 
                                        title={
                                                                                    <div className="arabic-font arabic-font-edit" style={{ 
                                            backgroundColor: '#f0f0f0',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            border: '1px solid #d9d9d9',
                                            color: '#000'
                                        }}
                                        dangerouslySetInnerHTML={{ __html: summaryNotes ? summaryNotes.replace(/<p>/g, '<span class="arabic-font arabic-font-edit">').replace(/<\/p>/g, '</span>') : '' }}
                                        />
                                        } 
                                        placement="top"
                                        overlayStyle={{ 
                                            backgroundColor: '#f0f0f0',
                                            color: '#000',
                                            maxWidth: '500px',
                                            width: '500px'
                                        }}
                                    >
                                        <div className="arabic-font-edit arabic-font" style={{ 
                                            width: '15vw',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}
                                        dangerouslySetInnerHTML={{ __html: summaryNotes ? summaryNotes.replace(/<p>/g, '<span class="arabic-font arabic-font-edit">').replace(/<\/p>/g, '</span>') : '' }}
                                        />
                                    </Tooltip>
                                );
                            }
                            return "";
                        },
                        onCell: (record) => {
                            if (groupsBySummary && record.isSummaryRow) {
                                return {
                                    rowSpan: 1,
                                    colSpan: 0 // Hide this column for summary rows
                                };
                            }
                            return {};
                        }
                    });
                
                // Add summary column for answer stacks when grouping is enabled
                if (isGrouped) {
                    // Don't add the Summary column when grouping is enabled since it's shown in the Name column
                    // columnsLettersStart.push({...});
                }

                break
            case "REVIEW_ANSWER":
                columnsLettersStart.push({
                    title: "Review Status",
                    dataIndex: ["reviewStatus"],
                    key: "reviewStatus",
                    filters: [
                        { text: 'Pending', value: 'PENDING' },
                        { text: 'Accepted', value: 'ACCEPTED' },
                        { text: 'Replaced', value: 'REPLACED' },
                        { text: 'Skipped', value: 'SKIPPED' },
                    ],
                    onFilter: (value, record) => (record.reviewStatus || 'PENDING') === value,
                    render: (reviewStatus, record) => {
                        const status = reviewStatus || 'PENDING';
                        const color = status === "ACCEPTED" ? "green"
                            : status === "REPLACED" ? "blue"
                            : status === "SKIPPED" ? "orange"
                            : "default";
                        const isCustomPdf = record.attachmentIdAnswerPdf && record.attachmentIdAnswerPdfOriginal && record.attachmentIdAnswerPdf !== record.attachmentIdAnswerPdfOriginal;
                        return <>
                            <Tag color={color}>{status.charAt(0) + status.slice(1).toLowerCase()}</Tag>
                            {isCustomPdf && <Tag color="purple">Custom PDF</Tag>}
                        </>;
                    },
                    onCell: (record) => {
                        if (groupsBySummary && record.isSummaryRow) {
                            return {
                                rowSpan: 1,
                                colSpan: 0 // Hide this column for summary rows
                            };
                        }
                        return {};
                    },
                });
                columnsLettersStart.push({
                    title: "Delivery",
                    dataIndex: ["deliveryMethod"],
                    key: "deliveryMethod",
                    filters: [
                        { text: 'Email', value: 'EMAIL' },
                        { text: 'Post', value: 'POST' },
                    ],
                    onFilter: (value, record) => record.deliveryMethod === value,
                    render: (deliveryMethod) => {
                        if (!deliveryMethod) return null;
                        const color = deliveryMethod === "EMAIL" ? "green" : "blue";
                        return <Tag color={color}>{deliveryMethod === "EMAIL" ? "Email" : "Post"}</Tag>;
                    },
                    onCell: (record) => {
                        if (groupsBySummary && record.isSummaryRow) {
                            return {
                                rowSpan: 1,
                                colSpan: 0 // Hide this column for summary rows
                            };
                        }
                        return {};
                    },
                });
                break
    }
    
    
        const columnsLetters = [...columnsLettersStart,
        {
            title: "Attachments",
            key: "attachmentIdAnswer",
            dataIndex: ["attachmentIdAnswer"],
            render: (attachmentIdAnswer, record) => {
                // Handle letter rows only (summary rows are hidden)
                return (
                    <>
                        {record.attachmentIdLetterToHudhur ? (
                            <a>
                                <Tag
                                    color="green"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownloadAttachment(record.attachmentIdLetterToHudhur);
                                    }}
                                    icon={<DownloadOutlined />}
                                >
                                    Letter
                                </Tag>
                            </a>
                        ) : (
                            ""
                        )}

                        {record.attachmentIdSummary ? (
                            <a>
                                <Tag
                                    color="red"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownloadAttachment(record.attachmentIdSummary);
                                    }}
                                    icon={<DownloadOutlined />}
                                >
                                    Summary
                                </Tag>
                            </a>
                        ) : (
                            ""
                        )}

                        {record.attachmentIdAnswerPdf ? (
                            <>
                                <br />
                                <a>
                                    <Tag
                                        color="purple"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleDownloadPdf(record);
                                        }}
                                        icon={<FilePdfOutlined />}
                                    >
                                        Answer PDF
                                    </Tag>
                                </a>
                            </>
                        ) : (
                            ""
                        )}
                        {record.attachmentIdAnswer ? (
                            <>
                                {" "}
                                <a>
                                    <Tag
                                        color="blue"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleDownloadAttachment(record.attachmentIdAnswer);
                                        }}
                                        icon={<FileWordOutlined />}
                                    >
                                        Answer Word
                                    </Tag>
                                </a>
                            </>
                        ) : (
                            ""
                        )}
                    </>
                );
            },
            onCell: (record) => {
                if (groupsBySummary && record.isSummaryRow) {
                    return {
                        rowSpan: 1,
                        colSpan: 0 // Hide this column for summary rows
                    };
                }
                return {};
            }
        },
        {
            title: "Status",
            key: "status",
            dataIndex: ["internalStatus"],
            filters: letterStatusFilterDropdown,
            onFilter: (value, record) => record.internalStatus.includes(value),
            sorter: (a, b) => a.internalStatus.localeCompare(b.internalStatus),
            render: (status, record) => {
                // Handle letter rows only (summary rows are hidden)
                return (
                    <Button type="text" style={{ backgroundColor: getProcessedLetterStatusColor(record),color:'white' }}>
                        {getProcessedLetterStatusLabel(record)}
                    </Button>
                );
            },
            onCell: (record) => {
                if (groupsBySummary && record.isSummaryRow) {
                    return {
                        rowSpan: 1,
                        colSpan: 0 // Hide this column for summary rows
                    };
                }
                return {};
            }
        },
        {
            title: "Letter ID",
            dataIndex: ["originalLetter", "letterId"],
            key: "letterId",
            sorter: (a, b) => {
                const aLetterId = a.originalLetter?.letterId || "";
                const bLetterId = b.originalLetter?.letterId || "";
                return aLetterId.localeCompare(bLetterId);
            },
            render: (letterId, record) => {
                // Handle letter rows only (summary rows are hidden)
                return letterId || "N/A";
            },
            onCell: (record) => {
                if (groupsBySummary && record.isSummaryRow) {
                    return {
                        rowSpan: 1,
                        colSpan: 0 // Hide this column for summary rows
                    };
                }
                return {};
            }
        },
    //     {
    //     title: "Date",
    //     dataIndex: ["originalLetter", "metaData", "created"],
    //     key: "date",
    //     defaultSortOrder: "ascend",
    //     render: (date) => (date ? moment(date).format("YYYY-MM-DD") : "N/A"),
    //     sorter: (a, b) => a.originalLetter.metaData.created.localeCompare(b.originalLetter.metaData.created),
    // },
    ];

    const onSelectChange = (newSelectedRowKeys, selectedRows, info) => {
        if (groupsBySummary) {
            // Handle summary row selection
            const summaryKeys = newSelectedRowKeys.filter(key => key.startsWith('summary-'));
            const letterKeys = newSelectedRowKeys.filter(key => !key.startsWith('summary-'));
            
            // Get all letter keys for selected summaries
            const additionalLetterKeys = [];
            summaryKeys.forEach(summaryKey => {
                const summaryId = summaryKey.replace('summary-', '');
                const summaryGroup = groupedData.find(item => item.key === summaryKey);
                if (summaryGroup) {
                    // Add all letters from this summary group
                    const lettersInGroup = groupedData.filter(item => 
                        !item.isSummaryRow && 
                        ""+item.summary?.id === summaryId
                    );
                    lettersInGroup.forEach(letter => {
                        if (!additionalLetterKeys.includes(letter.id)) {
                            additionalLetterKeys.push(letter.id);
                        }
                    });
                }
            });
            
            // Remove letters that belong to deselected summaries
            const previousSummaryKeys = selectedRowKeys.filter(key => key.startsWith('summary-'));
            const deselectedSummaryKeys = previousSummaryKeys.filter(key => !summaryKeys.includes(key));
            
            // Filter out letters that belong to deselected summaries
            const filteredLetterKeys = letterKeys.filter(letterKey => {
                const letter = groupedData.find(item => !item.isSummaryRow && item.id === letterKey);
                if (letter && letter.summary) {
                    const summaryId = "" + letter.summary.id;
                    return !deselectedSummaryKeys.some(summaryKey => 
                        summaryKey.replace('summary-', '') === summaryId
                    );
                }
                return true; // Keep letters without summary
            });
            
            // Combine letter keys and remove duplicates
            const allLetterKeys = [...new Set([...summaryKeys, ...filteredLetterKeys, ...additionalLetterKeys])];
            setSelectedRowKeys(allLetterKeys);
        } else {
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    const handleDeliverStack = () => {

        // check if summary order is define, if not, show error message
        if (stack.assignedStackType === "SUMMARY" && !stack.summaryOrder) {
            notification['error']({
                message: 'Summary order not defined',
                description: 'Please define the summary order before delivering the stack.',
            });
            return; 
        }
        
        dispatch(deliverStack({
            finalData: {stackId: params?.stackId},
            callbackSuccess: (response) => {
                console.log("Stack delivered successfully", response);
                if (isReviewMode) {
                    // Emails are sent in the background; stay on the page so the
                    // delivery progress is visible.
                    notification['success']({
                        message: 'Delivery started',
                        description:
                            'Stack #'+stack.id+' has been submitted. Answers are being delivered in the background; progress is shown on this page.',
                    });
                    refreshStack();
                    return;
                }
                notification['success']({
                    message: 'Stack delivered',
                    description:
                        'Stack #'+stack.id+' has been transmitted to supervisor.',
                });
                if(stack.assignedStackType === "SUMMARY" || stack.assignedStackType === "ANSWER")
                {
                    refreshStack();
                    handleDownloadStackAttachment();
                }
                else{
                    navigateToStacksView();
                }

            },
            callbackError: (error) => {
                console.error("Error delivering stack", error);
                notification['error']({
                    message: 'Error delivering stack',
                    description:error,
                });
            }
        }));
    };

    const handleExtendStack = () => {
        if (!extendAmount || extendAmount <= 0) {
            notification['error']({
                message: 'Invalid amount',
                description: 'Please enter an amount greater than 0.',
            });
            return;
        }
        dispatch(extendStack({
            finalData: {stackId: params?.stackId, extendStack: {additionalAmount: extendAmount}},
            callbackSuccess: (response) => {
                const addedLetters = (response?.assignedAmount || 0) - letters.length;
                notification['success']({
                    message: 'Stack extended',
                    description: addedLetters < extendAmount
                        ? 'Only ' + addedLetters + ' of ' + extendAmount + ' requested letter(s) were available and added to Stack #' + stack.id + '.'
                        : addedLetters + ' letter(s) added to Stack #' + stack.id + '.',
                });
                setIsExtendModalVisible(false);
                refreshStack();
            },
            callbackError: (error) => {
                console.error("Error extending stack", error);
                notification['error']({
                    message: 'Error extending stack',
                    description: error,
                });
            }
        }));
    };

    const handleSubmitReviewStack = () => {
        dispatch(submitReviewStack({
            finalData: { stackId: params?.stackId },
            callbackSuccess: (response) => {
                console.log("Review stack submitted successfully", response);
                notification['success']({
                    message: 'Stack submitted',
                    description: 'Stack #' + stack.id + ' has been sealed and queued for delivery.'
                });
                refreshStack();
            },
            callbackError: (error) => {
                console.error("Error submitting review stack", error);
                notification['error']({
                    message: 'Error submitting review stack',
                    description: error
                });
            }
        }));
    };

    const handleSubmitStack = () => {
        dispatch(submitStack({
            finalData: {stackId: params?.stackId},
            callbackSuccess: (response) => {
                console.log("Stack submitted successfully", response);
                notification['success']({
                    message: 'Stack submitted',
                    description:
                        'Stack #'+stack.id+' has been submitted.',
                });
                refreshStack();
                handleDownloadStackAttachment();
            },
            callbackError: (error) => {
                console.error("Error closing stack", error);
                notification['error']({
                    message: 'Error closing stack',
                    description:error,
                });
            }
        }));
    };

    const handleDownloadStackAttachment = (deliveryMethod) => {
        dispatch(downloadStackAttachment({
            finalData: {stackId: params?.stackId, deliveryMethod: deliveryMethod},
            callbackSuccess: (response) => {
                console.log("Download started", response);
                notification['success']({
                    message: 'Download started',
                    description:
                        'Stack #'+stack.id+' attachment download started.',
                });
            },
            callbackError: (error) => {
                console.error("Error downloading stack attachments", error);
                notification['error']({
                    message: 'Error downloading stack ',
                    description:error,
                });
            }
        }));
    };

    const handleDownloadAnswerWord = () => {
        const answerStackId = stack.linkedStack?.id || stack.referencedStackId;
        if (!answerStackId) {
            notification['error']({
                message: 'No answer stack',
                description: 'No answer stack found to download Word documents from.',
            });
            return;
        }
        dispatch(downloadStackAttachment({
            finalData: {stackId: answerStackId},
            callbackSuccess: (response) => {
                notification['success']({
                    message: 'Download started',
                    description: 'Answer Word download started.',
                });
            },
            callbackError: (error) => {
                notification['error']({
                    message: 'Error downloading answers',
                    description: error,
                });
            }
        }));
    };

    const handleDownloadAttachment = (attachmentId) => {
        dispatch(downloadAttachment({
            finalData: {id: attachmentId},
            callbackSuccess: (response) => {
                console.log("Download started", response);
                notification['success']({
                    message: 'Download started',
                    description:
                        'Download for Attachment with '+attachmentId+' started.',
                });
            },
            callbackError: (error) => {
                console.error("Error downloading attachment", error);
                notification['error']({
                    message: 'Error downloading attachment ',
                    description:error,
                });
            }
        }));
    };

    const handleDownloadPdf = (letter) => {
        if (!letter?.attachmentIdAnswerPdf) {
            notification['error']({
                message: 'No answer PDF available',
                description: 'This letter has no answer PDF to download.',
            });
            return;
        }
        dispatch(downloadAttachment({
            finalData: {id: letter.attachmentIdAnswerPdf},
            callbackSuccess: () => {
                notification['success']({
                    message: 'PDF Downloaded',
                    description: 'Answer PDF downloaded successfully.',
                });
            },
            callbackError: (error) => {
                notification['error']({
                    message: 'Error downloading PDF',
                    description: error,
                });
            }
        }));
    };

    const handleCloseStack = () => {
        dispatch(closeStack({
            finalData: {stackId: params?.stackId},
            callbackSuccess: (response) => {
                console.log("Stack closed successfully", response);
                notification['success']({
                    message: 'Stack closed',
                    description:
                        'Stack #'+stack.id+' has been closed.',
                });
                navigateToStacksView();
            },
            callbackError: (error) => {
                console.error("Error closing stack", error);
                notification['error']({
                    message: 'Error closing stack',
                    description:error,
                });
            }
        }));
    };

    const handleOpenSummaryOrderDialog = () => {
        setIsSummaryOrderModalVisible(true);
        // Reset to Stack Mode when opening the dialog
        // This will be handled by the SummaryOrderView component's initial state
    };

    const handleSaveToSettings = (newSummaryOrder) => {
        // First save to user settings
        dispatch(saveUserSettings({
            finalData: {
                userSettingsDto: {
                    settingName: "SUMMARY_ORDER",
                    settingData: newSummaryOrder
                }
            },
            callbackSuccess: (response) => {
                console.log('Saved to user settings:', response);
                // Update local state with the new setting data
                if (response && response.settingData) {
                    setUserSettingsSummaryOrder(response.settingData);
                }
                
                // Also save the stack-based summaries to the stack, ordered by user settings if available
                const stackSummaries = getSummariesList();
                const stackSummaryOrder = {};
                
                // First, add summaries that exist in user settings, ordered by user settings
                if (response.settingData && Object.keys(response.settingData).length > 0) {
                    const userSettingsOrderArray = Object.entries(response.settingData)
                        .map(([summaryId, orderNumber]) => ({ summaryId: parseInt(summaryId), order: orderNumber }))
                        .sort((a, b) => a.order - b.order);
                    
                    let currentOrder = 1;
                    userSettingsOrderArray.forEach(orderItem => {
                        const summary = stackSummaries.find(s => s.id === orderItem.summaryId);
                        if (summary) {
                            stackSummaryOrder[summary.id] = currentOrder++;
                        }
                    });
                }
                
                // Then add any remaining stack summaries that are not in user settings
                stackSummaries.forEach((summary) => {
                    if (!stackSummaryOrder.hasOwnProperty(summary.id)) {
                        stackSummaryOrder[summary.id] = Object.keys(stackSummaryOrder).length + 1;
                    }
                });
                
                dispatch(updateStackSummaryOrder({
                    finalData: {
                        id: stack.id,
                        requestBody: stackSummaryOrder
                    },
                    callbackSuccess: (stackResponse) => {
                        console.log('Saved to stack:', stackResponse);
                        notification.success({
                            message: 'Saved to User Settings and Stack',
                            description: 'Summary order has been saved to your user settings and the current stack.',
                        });
                        setIsSummaryOrderModalVisible(false);
                    },
                    callbackError: (stackError) => {
                        console.error('Error saving to stack:', stackError);
                        notification.error({
                            message: 'Error Saving to Stack',
                            description: stackError,
                        });
                    }
                }));
            },
            callbackError: (error) => {
                console.error('Error saving to user settings:', error);
                notification.error({
                    message: 'Error Saving to User Settings',
                    description: error,
                });
            }
        }));
    };

    const handleSaveToStack = (newSummaryOrder) => {
        dispatch(updateStackSummaryOrder({
            finalData: {
                id: stack.id,
                requestBody: newSummaryOrder
            },
            callbackSuccess: (response) => {
                console.log('Saved to stack:', response);
                notification.success({
                    message: 'Saved to Stack',
                    description: 'Summary order has been saved to the current stack.',
                });
                setIsSummaryOrderModalVisible(false);
            },
            callbackError: (error) => {
                console.error('Error saving to stack:', error);
                notification.error({
                    message: 'Error Saving to Stack',
                    description: error,
                });
            }
        }));
    };

    // Extract summaries from letters for the SummaryOrderView
    const getSummariesList = () => {
        const summaries = letters
            .filter(letter => letter.summary) // Only letters with summaries
            .map(letter => letter.summary);
        
        // Remove duplicates based on summary ID
        const distinctSummaries = summaries.filter((summary, index, self) => 
            index === self.findIndex(s => s.id === summary.id)
        );
        
        return distinctSummaries;
    };

    // Get all summaries created by or used by the user
    const getAllUserSummaries = () => {
        // Filter summaries to only include those created by or used by the current user
        const userProfile = getAuthenticatedUser()?.profile;
        
        const userSummaries = summaries.filter(summary => 
            summary.createdBy === userProfile.sub || 
            (summary.userIds && Array.from(summary.userIds).includes(userProfile.sub))
        );
        
        return userSummaries;
    };

    const showExportModal = () => {
        // Get visible columns from the table in the correct order
        const visibleColumns = columnsLetters.map(col => {
            switch(col.title) {
                case "Language": return "Letter Language";
                case "Status": return "Internal Status";
                case "Date": return "Letter Created";
                default: return col.title;
            }
        });

        // Additional columns to preselect
        const additionalPreselectedColumns = [
            "Sender First Name",
            "Sender Last Name",
            "Sender Urdu Name",
            "Sender Birthdate",
            "Sender Email",
            "Sender Jamaat",
            "Sender Country"
        ];

        // Get all other columns that are not in the table
        const otherColumns = Object.keys(allColumns).filter(key => !visibleColumns.includes(key));

        // Create initial selection with visible columns first, then others
        const initialSelection = {};
        [...visibleColumns, ...otherColumns].forEach(key => {
            initialSelection[key] = visibleColumns.includes(key) || additionalPreselectedColumns.includes(key);
        });

        setSelectedColumns(initialSelection);
        setIsExportModalVisible(true);
    };

    const handleExportToExcel = () => {
        // Get the actual letters data for export (not grouped structure)
        const lettersToExport = groupsBySummary 
            ? groupedData?.filter(item => !item.isSummaryRow) || []
            : letters || [];
            
        const data = lettersToExport.map(record => {
            const row = {};
            // Then add any other selected columns
            Object.keys(selectedColumns).forEach(key => {
                if (selectedColumns[key] && !row.hasOwnProperty(key)) {
                    switch(key) {
                        case 'Sender First Name':
                            row[key] = record.originalLetter?.sender?.firstName;
                            break;
                        case 'Sender Last Name':
                            row[key] = record.originalLetter?.sender?.lastName;
                            break;
                        case 'Sender Email':
                            row[key] = record.originalLetter?.sender?.email;
                            break;
                        case 'Sender Urdu Name':
                            row[key] = record.originalLetter?.sender?.urduName;
                            break;
                        case 'Sender Country':
                            row[key] = record.originalLetter?.sender?.country?.defaultLabel;
                            break;
                        case 'Sender Jamaat':
                            row[key] = record.originalLetter?.sender?.jamaat;
                            break;
                        case 'Letter Category':
                            row[key] = record.originalLetter?.category;
                            break;
                        case 'Sender Birthdate':
                            row[key] = record.originalLetter?.sender?.birthdate ? moment(record.originalLetter.sender.birthdate).format("YYYY-MM-DD") : "N/A";
                            break;
                        case 'Letter Language':
                            row[key] = record.originalLetter?.language;
                            break;
                        case 'Letter Content':
                            row[key] = record.originalLetter?.content;
                            break;
                        case 'Present to Huzoor':
                            row[key] = record.presentToHudhur ? 'Yes' : 'No';
                            break;
                        case 'Attachment ID Letter':
                            row[key] = record.attachmentIdLetterToHudhur;
                            break;
                        case 'Internal Status':
                            row[key] = record.internalStatus;
                            break;
                        case 'Letter Created':
                            row[key] = record.originalLetter?.metaData?.created ? moment(record.originalLetter.metaData.created).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        case 'Assigned To':
                            row[key] = record.assignedTo;
                            break;
                        case 'ID':
                            row[key] = record.id;
                            break;
                        case 'Summary Title English':
                            row[key] = record.summary?.titleEnglish;
                            break;
                        case 'Summary Title Urdu':
                            row[key] = record.summary?.titleUrdu;
                            break;
                        case 'Summary Topics':
                            row[key] = record.summary?.topics ? Array.from(record.summary.topics).join(', ') : '';
                            break;
                        case 'Summary Notes':
                            row[key] = record.summaryNotes;
                            break;
                        case 'Answer Language':
                            row[key] = record.answerLanguage;
                            break;
                        case 'Custom Answer':
                            row[key] = record.customAnswer;
                            break;
                        case 'Advice from Huzoor':
                            row[key] = record.adviceFromHudhur ? 'Yes' : 'No';
                            break;
                        case 'Filtered At':
                            row[key] = record.filteredAt ? moment(record.filteredAt).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        case 'Filtered By':
                            row[key] = record.filteredBy;
                            break;
                        case 'Filtered By Name':
                            row[key] = record.filteredByName;
                            break;
                        case 'Attachment ID Summary':
                            row[key] = record.attachmentIdSummary;
                            break;
                        case 'Summary At':
                            row[key] = record.summaryAt ? moment(record.summaryAt).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        case 'Summary Title Original':
                            row[key] = record.summaryTitleOriginal;
                            break;
                        case 'Summary By':
                            row[key] = record.summaryBy;
                            break;
                        case 'Summary By Name':
                            row[key] = record.summaryByName;
                            break;
                        case 'Answer At':
                            row[key] = record.answerAt ? moment(record.answerAt).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        case 'Answer Original':
                            row[key] = record.answerOriginal;
                            break;
                        case 'Answer By':
                            row[key] = record.answerBy;
                            break;
                        case 'Answer By Name':
                            row[key] = record.answerByName;
                            break;
                        case 'Attachment ID Answer':
                            row[key] = record.attachmentIdAnswer;
                            break;
                        case 'Created':
                            row[key] = record.created ? moment(record.created).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        case 'Created By':
                            row[key] = record.createdBy;
                            break;
                        case 'Created By Name':
                            row[key] = record.createdByName;
                            break;
                        case 'Modified':
                            row[key] = record.modified ? moment(record.modified).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        case 'Modified By':
                            row[key] = record.modifiedBy;
                            break;
                        case 'Modified By Name':
                            row[key] = record.modifiedByName;
                            break;
                        case 'Letter ID':
                            row[key] = record.originalLetter?.letterId;
                            break;
                        case 'Letter Updated':
                            row[key] = record.originalLetter?.metaData?.updated ? moment(record.originalLetter.metaData.updated).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        case 'Letter Created By':
                            row[key] = record.originalLetter?.metaData?.createdBy;
                            break;
                        case 'Letter Updated By':
                            row[key] = record.originalLetter?.metaData?.updatedBy;
                            break;
                        case 'Letter Version':
                            row[key] = record.originalLetter?.metaData?.version;
                            break;
                        case 'Sender ID':
                            row[key] = record.originalLetter?.sender?.id;
                            break;
                        case 'Sender AIMS ID':
                            row[key] = record.originalLetter?.sender?.aimsId;
                            break;
                        case 'Sender Street Line 1':
                            row[key] = record.originalLetter?.sender?.streetLine1;
                            break;
                        case 'Sender Street Line 2':
                            row[key] = record.originalLetter?.sender?.streetLine2;
                            break;
                        case 'Sender ZIP Code':
                            row[key] = record.originalLetter?.sender?.zipCode;
                            break;
                        case 'Sender City':
                            row[key] = record.originalLetter?.sender?.city;
                            break;
                        case 'Sender State':
                            row[key] = record.originalLetter?.sender?.state;
                            break;
                        case 'Sender Country Code':
                            row[key] = record.originalLetter?.sender?.country?.code;
                            break;
                        case 'Sender Country Flag':
                            row[key] = record.originalLetter?.sender?.country?.values?.flag;
                            break;
                        case 'Sender Gender':
                            row[key] = record.originalLetter?.sender?.gender;
                            break;
                        case 'Sender Contact Number':
                            row[key] = record.originalLetter?.sender?.contactNumber;
                            break;
                        case 'Sender Approval Status':
                            row[key] = record.originalLetter?.sender?.approvalStatus;
                            break;
                        case 'Sender Email Verified':
                            row[key] = record.originalLetter?.sender?.emailVerified ? 'Yes' : 'No';
                            break;
                        case 'Sender Created Timestamp':
                            row[key] = record.originalLetter?.sender?.createdTimestamp ? moment(record.originalLetter.sender.createdTimestamp).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        case 'Review Status':
                            row[key] = record.reviewStatus;
                            break;
                        case 'Delivery Method':
                            row[key] = record.deliveryMethod;
                            break;
                        case 'Reviewed At':
                            row[key] = record.reviewedAt ? moment(record.reviewedAt).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        case 'Reviewed By':
                            row[key] = record.reviewedBy;
                            break;
                        case 'Reviewed By Name':
                            row[key] = record.reviewedByName;
                            break;
                        case 'Attachment ID Answer PDF':
                            row[key] = record.attachmentIdAnswerPdf;
                            break;
                        case 'Attachment ID Answer PDF Original':
                            row[key] = record.attachmentIdAnswerPdfOriginal;
                            break;
                        case 'Modified Answer PDF Uploaded By':
                            row[key] = record.modifiedAnswerPdfUploadedBy;
                            break;
                        case 'Modified Answer PDF Uploaded At':
                            row[key] = record.modifiedAnswerPdfUploadedAt ? moment(record.modifiedAnswerPdfUploadedAt).format("YYYY-MM-DD HH:mm:ss") : "N/A";
                            break;
                        default:
                            //row[key] = "N/A";
                    }
                }
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Letters");
        XLSX.writeFile(workbook, "stack_letters_export.xlsx");

        notification['success']({
            message: 'Export Successful',
            description: 'Letters exported to Excel successfully.',
        });
        setIsExportModalVisible(false);
    };

    const handleColumnSelection = (column, checked) => {
        setSelectedColumns(prev => ({
            ...prev,
            [column]: checked
        }));
    };

    const handleSelectAll = (checked) => {
        const newSelection = {};
        Object.keys(allColumns).forEach(key => {
            newSelection[key] = checked;
        });
        setSelectedColumns(newSelection);
    };

    const handleDownloadSelectedRows = () => {
        if (selectedRowKeys.length === 0) {
            notification['warning']({
                message: 'No data selected',
                description: 'Please select at least one row to download.',
            });
            return;
        }

        // Filter out summary row keys (keys that start with 'summary-')
        const filteredRowKeys = selectedRowKeys.filter(key => !key.startsWith('summary-'));

        if (filteredRowKeys.length === 0) {
            notification['warning']({
                message: 'No letters selected',
                description: 'Please select at least one letter to download.',
            });
            return;
        }

        // Get the selected letters (handle both grouped and ungrouped data)
        const selectedLetters = groupsBySummary
            ? groupedData?.filter(letter => letter && !letter.isSummaryRow && filteredRowKeys.includes(letter.id)) || []
            : filteredLetters?.filter(letter => letter && filteredRowKeys.includes(letter.id)) || [];

        if (selectedLetters.length === 0) {
            notification['warning']({
                message: 'No letters selected',
                description: 'Please select at least one letter to download.',
            });
            return;
        }

        // Pass the filtered letter IDs to the API (excluding summary row keys)
        dispatch(downloadMultipleLetters({
            finalData: { ids: filteredRowKeys },
            callbackSuccess: (response) => {
                console.log("Multiple letters download started", response);
                notification['success']({
                    message: 'Download started',
                    description: `Download started for ${selectedLetters.length} selected letter(s).`,
                });
            },
            callbackError: (error) => {
                console.error("Error downloading multiple letters", error);
                notification['error']({
                    message: 'Error downloading letters',
                    description: error,
                });
            }
        }));
    };

    const handleAddInstructions = (values) => {
        const { letters } = values;
        
        // Filter out summary row keys (keys that start with 'summary-')
        const filteredRowKeys = selectedRowKeys.filter(key => !key.startsWith('summary-'));
        
        // Get the selected letters (handle both grouped and ungrouped data)
        const selectedLetters = groupsBySummary
            ? groupedData?.filter(letter => letter && !letter.isSummaryRow && filteredRowKeys.includes(letter.id)) || []
            : filteredLetters?.filter(letter => letter && filteredRowKeys.includes(letter.id)) || [];

        if (selectedLetters.length === 0) {
            notification['warning']({
                message: 'No letters selected',
                description: 'Please select at least one letter to add instructions.',
            });
            return;
        }

        // Validate that all letters have instructions
        const lettersWithInstructions = Object.keys(letters || {});
        if (lettersWithInstructions.length === 0) {
            notification['warning']({
                message: 'No instructions provided',
                description: 'Please provide instructions for at least one letter.',
            });
            return;
        }

        // Prepare data for API call
        const letterInstructions = Object.entries(letters).map(([letterId, data]) => {
            // Find the current letter to get its current status
            const currentLetter = selectedLetters.find(letter => letter.id === letterId);
            const currentStatus = currentLetter?.internalStatus || 'LETTER_IN_ANSWER';
            
            let newStatus;
            if (data.skipAnswer) {
                newStatus = 'LETTER_INTERNAL_FORWARDED';
            } else if (currentStatus === 'LETTER_INTERNAL_FORWARDED') {
                newStatus = 'LETTER_IN_ANSWER';
            } else {
                newStatus = currentStatus;
            }
            
            return {
                letterId: letterId,
                commentDto: {
                    commentText: data.instructions,
                    subject: 'INSTRUCTIONS'
                },
                status: newStatus
            };
        });

        const requestData = {
            letterInstructions: letterInstructions
        };

        console.log('Calling API with data:', requestData);

        // Call the API to add instructions
        dispatch(addInstructions({
            finalData: requestData,
            callbackSuccess: (response) => {
                console.log('Instructions added successfully:', response);
                
                // Update the stack with the returned letters
                if (refreshStack) {
                    refreshStack();
                }
                
                // Trigger download for letters where skip answer was checked
                const skippedLetterIds = Object.entries(letters)
                    .filter(([letterId, data]) => data.skipAnswer)
                    .map(([letterId]) => letterId);
                
                if (skippedLetterIds.length > 0) {
                    console.log('Downloading skipped letters:', skippedLetterIds);
                    dispatch(downloadMultipleLetters({
                        finalData: { ids: skippedLetterIds },
                        callbackSuccess: (downloadResponse) => {
                            console.log("Download started for skipped letters", downloadResponse);
                            notification['success']({
                                message: 'Download Started',
                                description: `Download started for ${skippedLetterIds.length} skipped letter(s).`,
                            });
                        },
                        callbackError: (downloadError) => {
                            console.error("Error downloading skipped letters", downloadError);
                            notification['warning']({
                                message: 'Download Warning',
                                description: `Instructions added but download failed for skipped letters: ${downloadError}`,
                            });
                        }
                    }));
                }
                
                notification['success']({
                    message: 'Instructions Added',
                    description: `Instructions have been added to ${lettersWithInstructions.length} selected letter(s).`,
                });
                setIsInstructionsModalVisible(false);
            },
            callbackError: (error) => {
                console.error('Error adding instructions:', error);
                notification['error']({
                    message: 'Error Adding Instructions',
                    description: error,
                });
            }
        }));
    };





    const renderButtonWithConfirmation = (action, status, label, percentage, loading = false, blocked = false) => {
        const allowSubmit = areLetterProcessed(status, percentage)
        // Filter out forwarded letters when checking unprocessed letters
        const nonForwardedLetters = letters.filter(letter => letter.internalStatus !== 'LETTER_INTERNAL_FORWARDED');
        const lettersNotProcessed = nonForwardedLetters.filter(letter => letter.internalStatus !== status).length;
        if(lettersNotProcessed > 0 && allowSubmit)
        {
            return <Popconfirm placement="left" title={"There is/are still "+lettersNotProcessed+" unprocessed Letter/s, are you sure to continue?"} onConfirm={action}>
                <Button className={"ant-tag-green"} disabled={!allowSubmit || loading || blocked} loading={loading} type="default"><SafetyOutlined/>{label}</Button>
            </Popconfirm>
        }else{
            return <Button className={"ant-tag-green"} disabled={!allowSubmit || loading || blocked} loading={loading} type="default" onClick={action}><SafetyOutlined/>{label}</Button>
        }

    }
    
    const stackLabel = (s) => s.assignedStackType.charAt(0).toUpperCase() + s.assignedStackType.slice(1).toLowerCase() + "-Stack #" + s.id;
    const linkedStackLabels = [];
    for (let linked = stack.linkedStack; linked; linked = linked.linkedStack) {
        linkedStackLabels.push(stackLabel(linked));
    }

    return (
        <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={
                <div>
                    <div style={{ marginBottom: '12px' }}>
                        <Space>
                            <span>{stackLabel(stack) + (linkedStackLabels.length > 0 ? " (" + linkedStackLabels.join(", ") + ")" : "")}</span>
                            {stack.assignedLanguages && stack.assignedLanguages.length > 0 && (
                                <span style={{ 
                                    backgroundColor: '#f0f0f0', 
                                    padding: '4px 8px', 
                                    borderRadius: '4px', 
                                    fontSize: '12px',
                                    color: '#666',
                                    border: '1px solid #d9d9d9'
                                }}>
                                    {getLanguagesLabel(stack.assignedLanguages[0])}
                                </span>
                            )}
                            <span style={{ 
                                backgroundColor: '#f6ffed', 
                                padding: '4px 8px', 
                                borderRadius: '4px', 
                                fontSize: '12px',
                                color: '#52c41a',
                                border: '1px solid #b7eb8f'
                            }}>
                                Processed Letters {letters.filter(letter => !letter.internalStatus.startsWith('LETTER_IN')).length}/{letters.length}
                            </span>
                            {showDeliveryProgress && (() => {
                                const progress = deliveryProgress();
                                return (
                                    <Space size={4}>
                                        {progress.pending > 0 && (
                                            <Tooltip title={progress.done + " of " + progress.total + " letter(s) through the delivery process. This page refreshes itself while any are still queued."}>
                                                <Tag color="processing" icon={<SyncOutlined spin />}>
                                                    Delivering {Math.round((progress.done / progress.total) * 100)}%
                                                </Tag>
                                            </Tooltip>
                                        )}
                                        <Tooltip title="Answers delivered by e-mail">
                                            <Tag color="blue"><MailOutlined /> {progress.delivered} delivered</Tag>
                                        </Tooltip>
                                        <Tooltip title="Answer PDFs downloaded">
                                            <Tag color="green">{progress.downloaded} downloaded</Tag>
                                        </Tooltip>
                                        <Tooltip title="Letters sent by post">
                                            <Tag><PrinterOutlined /> {progress.posted} posted</Tag>
                                        </Tooltip>
                                        <Tooltip title="E-mail delivery failed — these need attention">
                                            <Tag color="red"><WarningOutlined /> {progress.failed} failed</Tag>
                                        </Tooltip>
                                    </Space>
                                );
                            })()}
                        </Space>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Space>
                            <Button className={"ant-tag-green"} type="default" onClick={showExportModal}><FileExcelOutlined/> Export as Excel</Button>
                            <Button 
                                className={"ant-tag-blue"} 
                                type="default" 
                                disabled={selectedRowKeys.length === 0}
                                onClick={() => handleDownloadSelectedRows()}
                            >
                                <DownloadOutlined/> Download Selected
                            </Button>
                            {stack.assignedStackType === "ANSWER" && (
                                <Button 
                                    className={"ant-tag-green"} 
                                    type="default" 
                                    disabled={selectedRowKeys.length === 0}
                                    onClick={() => setIsInstructionsModalVisible(true)}
                                >
                                    <FileProtectOutlined/> Add Instructions
                                </Button>
                            )}
                        </Space>
                        {(() => {
                            const actualSelectedLetters = selectedRowKeys.filter(key => !key.startsWith('summary-'));
                            return actualSelectedLetters.length > 0 && (
                                <div style={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    padding: '4px 12px',
                                    backgroundColor: '#f0f0f0',
                                    borderRadius: '4px',
                                    border: '1px solid #d9d9d9',
                                    minWidth: '120px',
                                    justifyContent: 'center'
                                }}>
                                    <span style={{ color: '#8c8c8c' }}>
                                        {actualSelectedLetters.length} letter(s) selected
                                    </span>
                                </div>
                            );
                        })()}
                        <Space>
                            {stack.assignedStackType === "ANSWER" && (
                                <Space>
                                </Space>
                            )}
                            <Input
                                placeholder="Search..."
                                onChange={e => setSearchText(e.target.value)}
                                style={{ width: 200 }}
                            />
                            <Button className={"ant-tag-close-icon"} type="default" onClick={() => {window.history.back()}}>
                                <LeftCircleOutlined/>Back
                            </Button>
                            {isReviewMode ? (
                                <>
                                    {(stack.status === "DELIVERED" || stack.status === "SUBMITTED" || stack.status === "CLOSED") && (
                                        <>
                                            <Button className={"ant-tag-blue"} type="default" onClick={() => handleDownloadStackAttachment()}>
                                                <FilePdfOutlined /> All PDFs
                                            </Button>
                                            <Button className={"ant-tag-green"} type="default" onClick={() => handleDownloadStackAttachment("EMAIL")}>
                                                <MailOutlined /> Email PDFs
                                            </Button>
                                            <Button className={"ant-tag-orange"} type="default" onClick={() => handleDownloadStackAttachment("POST")}>
                                                <PrinterOutlined /> Post PDFs
                                            </Button>
                                            <Button className={"ant-tag-blue"} type="default" onClick={handleDownloadAnswerWord}>
                                                <FileWordOutlined /> Answer Word
                                            </Button>
                                        </>
                                    )}
                                    {stack.status === "ASSIGNED" && (() => {
                                        const blockedReason = deliveryBlockedReason();
                                        const button = renderButtonWithConfirmation(
                                            handleDeliverStack, "LETTER_ANSWER_REVIEWED", " Start Delivery",
                                            1, isDeliverStackLoading, blockedReason !== null);
                                        return blockedReason
                                            ? <Tooltip title={blockedReason}><span>{button}</span></Tooltip>
                                            : button;
                                    })()}
                                    {stack.status === "DELIVERED" && (
                                        allLettersReviewed() ? (
                                            <Popconfirm
                                                placement="left"
                                                title="This will seal all letters and send answers for delivery. This cannot be undone. Proceed?"
                                                onConfirm={handleSubmitReviewStack}
                                            >
                                                <Button className={"ant-tag-green"} type="default">
                                                    <SafetyOutlined /> Submit and Send Answers
                                                </Button>
                                            </Popconfirm>
                                        ) : (
                                            <Tooltip title="Review all letters before submitting">
                                                <Button className={"ant-tag-green"} type="default" disabled>
                                                    <SafetyOutlined /> Submit and Send Answers
                                                </Button>
                                            </Tooltip>
                                        )
                                    )}
                                </>

                            ) : (
                                <>
                                    {
                                        stack.status === "ASSIGNED" ?
                                            (stack.assignedStackType === "FILTRATION" ? renderButtonWithConfirmation(handleDeliverStack, "LETTER_FILTERED", " Submit Filtration", 0.01) :
                                                stack.assignedStackType === "SUMMARY" ? <>
                                                    <Button className={"ant-tag-blue"} type="default" onClick={() => setIsExtendModalVisible(true)}><PlusCircleOutlined/> Extend Stack</Button>
                                                    {renderButtonWithConfirmation(handleDeliverStack, "LETTER_SUMMARIZED", " Submit & Print Summaries",0.01)}
                                                    {areLetterProcessed("LETTER_SUMMARIZED", 0.01) &&
                                                        <Button className={"ant-tag-blue"} type="default" onClick={handleOpenSummaryOrderDialog}><DragOutlined/> Set Summary Order</Button>
                                                    }
                                                </> :
                                                    stack.assignedStackType === "ANSWER" ? renderButtonWithConfirmation(handleDeliverStack, "LETTER_ANSWERED", " Submit & Print Answers", 1) :
                                                        "")
                                            : ""}
                                    {
                                        (stack.status === "DELIVERED" || stack.status === "SUBMITTED")?
                                            ((stack.assignedStackType === "FILTRATION") && getAuthenticatedUser().isPortalSupervisor() ? <Button className={"ant-tag-blue"} type="default" onClick={handleCloseStack}><SafetyCertificateOutlined /> Approve Filtration</Button> :
                                                stack.assignedStackType === "SUMMARY" ? <>
                                                                                            <Button className={"ant-tag-green"} type="default" onClick={handleDownloadStackAttachment}><DownloadOutlined /> Download Attachments</Button>
                                                                                            <Button className={"ant-tag-blue"} type="default" onClick={handleCloseStack}><FileProtectOutlined />Summary viewed by Huzoor<sup>aa</sup></Button>
                                                                                        </>:
                                                    stack.assignedStackType === "ANSWER" ? <>
                                                                                                <Button className={"ant-tag-green"} type="default" onClick={handleDownloadStackAttachment}><DownloadOutlined /> Download Attachments</Button>
                                                                                                <Button className={"ant-tag-blue"} type="default" onClick={handleCloseStack}><FileProtectOutlined />Archive Stack</Button>
                                                                                            </> :
                                                                "")
                                            : ""}
                                </>
                            )}
                        </Space>
                    </div>
                </div>
            }
            extra={null}
        >
            <div className="table-responsive">
                {showDeliveryProgress && !isDeliveryInProgress && deliveryProgress().failed > 0 && (
                    <Alert
                        type="warning"
                        showIcon
                        style={{ margin: '12px 24px' }}
                        message={deliveryProgress().failed + " letter(s) could not be delivered."}
                        description="Filter the Status column by 'Answer Delivery failed', open the letter and retry the delivery from there."
                    />
                )}
                <Table
                    rowSelection={{
                        selectedRowKeys,
                        onChange: (selectedKeys, selectedRows, info) => {
                            // Show alert for testing
                            console.log(JSON.stringify(info));
                            console.log(JSON.stringify(selectedRows));
                            console.log(JSON.stringify(selectedKeys));
                            onSelectChange(selectedKeys, selectedRows, info);
                        },
                        selections: [
                            {
                                key: 'all-data',
                                text: 'Select All Data',
                                onSelect: () => {
                                    const allKeys = groupsBySummary 
                                        ? groupedData?.filter(item => !item.isSummaryRow).map(item => item.id).filter(Boolean) || []
                                        : filteredLetters?.map(item => item?.id).filter(Boolean) || [];
                                    setSelectedRowKeys(allKeys);
                                },
                            },
                            {
                                key: 'clear-all',
                                text: 'Clear All',
                                onSelect: () => {
                                    setSelectedRowKeys([]);
                                },
                            },
                        ],
                        getCheckboxProps: (record) => {
                            // Enable checkboxes for all rows including summary rows
                            return {};
                        }
                    }}
                    columns={columnsLetters}
                    dataSource={groupedData}
                    pagination={false}
                    className="ant-border-space"
                    rowKey={(record) => {
                        if (groupsBySummary && record?.isSummaryRow) {
                            return `summary-${record.summaryName}`;
                        }
                        return record?.id || `row-${Math.random()}`;
                    }}
                    onRow={(record, rowIndex) => {
                        // Handle summary rows differently
                        if (groupsBySummary && record?.isSummaryRow) {
                            return {
                                onDoubleClick: (event) => {},
                                onClick: (event) => {},
                                onContextMenu: (event) => {},
                                onMouseEnter: (event) => {},
                                onMouseLeave: (event) => {},
                            };
                        }
                        
                        return {
                            onDoubleClick: (event) => {},
                            onClick: (event) => {
                                if (record) {
                                    navigateToLetterView(record);
                                }
                            },
                            onContextMenu: (event) => {},
                            onMouseEnter: (event) => {},
                            onMouseLeave: (event) => {},
                        };
                    }}
                />
            </div>
            <Modal
                title="Select Columns for Export"
                open={isExportModalVisible}
                onOk={handleExportToExcel}
                onCancel={() => setIsExportModalVisible(false)}
                width={600}
            >
                <div style={{ marginBottom: 16 }}>
                    <Checkbox
                        onChange={(e) => handleSelectAll(e.target.checked)}
                        checked={Object.values(selectedColumns).every(v => v)}
                    >
                        Select All
                    </Checkbox>
                </div>
                <div style={{ maxHeight: 400, overflow: 'auto' }}>
                    {Object.keys(allColumns).map(column => (
                        <div key={column} style={{ marginBottom: 8 }}>
                            <Checkbox
                                checked={selectedColumns[column]}
                                onChange={(e) => handleColumnSelection(column, e.target.checked)}
                            >
                                {column}
                            </Checkbox>
                        </div>
                    ))}
                </div>
            </Modal>
            <Modal
                title={"Extend Stack #" + stack.id}
                open={isExtendModalVisible}
                onOk={handleExtendStack}
                okText="Extend"
                onCancel={() => setIsExtendModalVisible(false)}
            >
                <p>How many additional letters should be assigned to this stack? If fewer letters are available, only those will be added.</p>
                <InputNumber
                    min={1}
                    value={extendAmount}
                    onChange={setExtendAmount}
                    style={{ width: '100%' }}
                />
            </Modal>
            <SummaryOrderView
                key={isSummaryOrderModalVisible ? 'open' : 'closed'}
                visible={isSummaryOrderModalVisible}
                onCancel={() => setIsSummaryOrderModalVisible(false)}
                summariesList={getSummariesList()}
                allUserSummaries={getAllUserSummaries()}
                userSettingsSummaryOrder={userSettingsSummaryOrder}
                currentSummaryOrder={stack.summaryOrder || {}}
                onSaveToSettings={handleSaveToSettings}
                onSaveToStack={handleSaveToStack}
            />
            
            <AddInstructionsDialog
                visible={isInstructionsModalVisible}
                onCancel={() => setIsInstructionsModalVisible(false)}
                onOk={handleAddInstructions}
                selectedLetters={(() => {
                    const selectedLetters = groupsBySummary
                        ? groupedData?.filter(letter => letter && !letter.isSummaryRow && selectedRowKeys.includes(letter.id)) || []
                        : filteredLetters?.filter(letter => letter && selectedRowKeys.includes(letter.id)) || [];
                    return selectedLetters;
                })()}
                stackType={stack.assignedStackType}
                stackId={stack.id}
                isGrouped={isGrouped}
            />
        </Card>
    );
}